"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getQuery = exports.ApiError = void 0;
var ApiError = (function (_super) {
    __extends(ApiError, _super);
    function ApiError(errors, skipGoToAuth) {
        if (skipGoToAuth === void 0) { skipGoToAuth = false; }
        var _this = _super.call(this, errors.join(';')) || this;
        _this.skipGoToAuth = skipGoToAuth;
        _this._errors = errors;
        return _this;
    }
    Object.defineProperty(ApiError.prototype, "errors", {
        get: function () {
            return this._errors;
        },
        enumerable: false,
        configurable: true
    });
    return ApiError;
}(Error));
exports.ApiError = ApiError;
function getQuery(query) {
    var sp = new URLSearchParams();
    Object.entries(query !== null && query !== void 0 ? query : {}).forEach(function (_a) {
        var _b = __read(_a, 2), k = _b[0], v = _b[1];
        return v !== undefined && sp.set(k, "".concat(v));
    });
    return sp.toString();
}
exports.getQuery = getQuery;
var Api = (function () {
    function Api(host) {
        this._token = null;
        this._userUid = null;
        this._host = host;
    }
    Api.prototype.query = function (path, opts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var headers, optsWithCookies, resp, message, _c, _d, err_1, text;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 5, , 6]);
                        headers = __assign({}, opts.headers);
                        if ((_a = this.token) === null || _a === void 0 ? void 0 : _a.access) {
                            headers['token'] = (_b = this.token) === null || _b === void 0 ? void 0 : _b.access;
                        }
                        if (this.userUid) {
                            headers['uid'] = this.userUid;
                        }
                        optsWithCookies = __assign(__assign({}, opts), { credentials: 'include' });
                        return [4, fetch("".concat(this._host).concat(path), __assign(__assign({}, optsWithCookies), { headers: headers }))];
                    case 1:
                        resp = _e.sent();
                        if (!!resp.ok) return [3, 3];
                        return [4, resp.json().then(function (data) { return data.message; })];
                    case 2:
                        message = _e.sent();
                        throw new Error("status: ".concat(resp.status.toString(), "; statusText: ").concat(resp.statusText, "; message: ").concat(message));
                    case 3:
                        _c = this.handleResponse;
                        _d = [path, opts];
                        return [4, resp.json()];
                    case 4: return [2, _c.apply(this, _d.concat([_e.sent()]))];
                    case 5:
                        err_1 = _e.sent();
                        text = "".concat(err_1);
                        if (/^5/.test(text)) {
                            text = 'Произошла ошибка на сервере. Попробуйте обновить страницу';
                            this.showError(text);
                        }
                        console.log('Fetch error:', path, err_1);
                        throw new ApiError([text], true);
                    case 6: return [2];
                }
            });
        });
    };
    Api.prototype.queryGET = function (path, data, headers) {
        var sp = getQuery(data);
        return this.query(sp ? "".concat(path, "?").concat(sp) : path, {
            method: 'GET',
            headers: __assign({}, headers)
        });
    };
    Api.prototype.queryPUT = function (path, data) {
        return this.queryP_T(path, 'PUT', data);
    };
    Api.prototype.queryPOST = function (path, data, headers) {
        return this.queryP_T(path, 'POST', data, headers);
    };
    Api.prototype.queryDELETE = function (path, data, headers) {
        var sp = getQuery(data);
        return this.query(sp ? "".concat(path, "?").concat(sp) : path, {
            method: 'DELETE',
            headers: __assign({}, headers)
        });
    };
    Object.defineProperty(Api.prototype, "token", {
        get: function () {
            if (this._token) {
                return this._token;
            }
            var ls = localStorage.getItem('token');
            if (!ls) {
                return null;
            }
            return JSON.parse(ls);
        },
        set: function (v) {
            this._token = v;
            localStorage.setItem('token', JSON.stringify(v));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Api.prototype, "userUid", {
        get: function () {
            if (this._token) {
                return this._userUid;
            }
            var ls = localStorage.getItem('userUid');
            if (!ls) {
                return null;
            }
            return ls;
        },
        set: function (v) {
            this._userUid = v;
            localStorage.setItem('userUid', v || '');
        },
        enumerable: false,
        configurable: true
    });
    Api.prototype.queryP_T = function (path, method, data, headers) {
        return this.query(path, {
            method: method,
            headers: __assign(__assign({}, headers), { 'Content-Type': 'application/json;charset=utf-8' }),
            body: JSON.stringify(data)
        });
    };
    return Api;
}());
exports.default = Api;
